
import { defineComponent, onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { axios } from '@/plugins/axios'
import { ElNotification } from 'element-plus'

import Loading from '@/components/tools/SurveyToolLoading.vue'
import Start from '@/components/tools/SurveyToolStart.vue'
import Proceeding from '@/components/tools/SurveyToolProceeding.vue'
import Result from '@/components/tools/SurveyToolResult.vue'
import Tallying from '@/components/tools/SurveyToolTallying.vue'

interface surveyData {
 number : number,
 maxNum : number,
 finished : number,
 started : number,
 title : string,
}

interface State {
 loading : boolean,
 userRunk: any,
 btnConf: any
}

export default defineComponent({
  components: { 
    Loading,
    Start,
    Proceeding,
    Result,
    Tallying
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const surveyData = reactive<surveyData>({
      number: 1,
      maxNum: 1,
      finished: 0,
      started: 0,
      title: '',
    })

    const state = reactive<State>({
      loading: false,
      userRunk: 0,
      btnConf: 
      {
        text: '',
        color: '',
        neworpay: 0,
        trade: 0
      }
    })

    const btnConfState = {
      newBtnConf: [
        {
          text: '新規・買い',
          color: 'red',
          neworpay: 1,
          trade: 1
        },
        {
          text: '新規・売り',
          color: 'blue',
          neworpay: 1,
          trade: 2
        }
      ],
      payBuyBtnConf: [
        {
          text: '決済・買い',
          color: 'yellow',
          neworpay: 2,
          trade: 1
        }
      ],
      paySellBtnConf: [
        {
          text: '決済・売り',
          color: 'green',
          neworpay: 2,
          trade: 2
        }
      ] 
    }

    /************************
     *  ボタン押下時
     ************************/
    const answer = async(item:any) =>{
      state.loading = true
      const sendData = {
        number: surveyData.number,
        neworpay: item.neworpay,
        trade: item.trade
      }

      const api = '/survey-tool/post-user-profitloss/' + route.params.survey_tool_id

      // await new Promise(resolve => setTimeout(resolve, 1000)) //連打防止
      // await axios
      //   .post(api, sendData)
      //   .then(res => {
      //     if (res.data.sync_data.status != 'finished') {
      //       if (res.data.sync_data.status == 'now_num_sync') {
      //         notify('番号をスキップしました。', 'success')
      //         surveyData.number = res.data.sync_data.number
      //       } else {
      //         changeBtn(item.neworpay, item.trade)
      //         // 回答番号進める
      //         notify('送信しました。', 'success')
      //         surveyData.number = surveyData.number + 1
      //       }
      //     }
      //     surveyData.finished = res.data.finished
      //   })
      //   .catch(error => {
      //     notify('送信に失敗しました。', 'error')
      //   })

      const promises = [
        axios
          .post(api, sendData)
          .then(res => {
            if (res.data.sync_data.status != 'finished') {
              if (res.data.sync_data.status == 'now_num_sync') {
                notify('番号をスキップしました。', 'success')
                surveyData.number = res.data.sync_data.number
              } else {
                changeBtn(item.neworpay, item.trade)
                // 回答番号進める
                notify('送信しました。', 'success')
                surveyData.number = surveyData.number + 1
              }
            }
            surveyData.finished = res.data.finished
          })
          .catch(error => {
            notify('送信に失敗しました。', 'error')
          }),
        new Promise(resolve => setTimeout(resolve, 500)) //連打防止
      ]

      await Promise.allSettled(promises)

      if (surveyData.finished == 1) {
        // await this.fetchUserRank()
      }
      state.loading = false
    }

    /************************
     *  ボタン押下後メッセージ
     ************************/
    const notify = (message:string, type:any, duration=2500) =>{
      ElNotification({
        dangerouslyUseHTMLString: true,
        message: message,
        position: 'bottom-right',
        type: type,
        duration: duration
      })
    }

    /************************
     *  ボタン切り替え
     ************************/
    const changeBtn= (neworpay:any, trade:any) => {
      // ボタンの切り替え
      if (neworpay == 1) {
        if (trade == 1) {
          state.btnConf = btnConfState.paySellBtnConf
        } else if (trade == 2) {
          state.btnConf = btnConfState.payBuyBtnConf
        }
      } else if (neworpay == 2) {
        state.btnConf = btnConfState.newBtnConf
      }
    }

    const fetchSurveyData = async() =>{
      state.loading = true

      const api = '/survey-tool/fetch-data/' + route.params.survey_tool_id
      await axios.get(api)
        .then(res => {
          if (res.data.status == 'no_data') {
          // survey_tool_idが存在しない場合は404ページへ
            router.push('/error')
          }
          else {
            surveyData.number = res.data.user_now_num
            surveyData.maxNum = res.data.max_num
            surveyData.finished = res.data.finished
            surveyData.started = res.data.started
            surveyData.title = res.data.title
            changeBtn(res.data.neworpay, res.data.trade)
          }
          state.loading = false

        })
        .catch(error => {
          notify('情報を取得できませんでした。', 'error')
        })
    }

    const fetchUserRank = async() =>{
      state.loading = true
      const api = '/survey-tool/fetch-user-rank/' + route.params.survey_tool_id
      await axios.get(api)
        .then(res => {
          if (res.data.status == 'no_data') {
          // survey_tool_idが存在しない場合は404ページへ
            router.push('/error')
          }
          else {
            state.userRunk = res.data
          }
          state.loading = false
        })
        .catch(error => {
          // notify('情報を取得できませんでした。', 'error')
          notify('情報を取得できませんでした。', 'error')
        })
    }

    const reload = () => {
      location.reload()
    }

    onMounted(async () => {
      state.btnConf = btnConfState.newBtnConf
      await fetchSurveyData()
      if (surveyData.finished==1) {
        await fetchUserRank()
      }
    })

    return {
      fetchSurveyData,
      answer,
      reload,
      surveyData,
      state,
      notify,
    }
  },
})
